<template>
  <div class="wl-certificate-student">
    <div class="certificate-student-content clearfix">
      <div class="wl-sidebar-menu">
        <div class="wl-lecturer-back clearfix" :style="{backgroundImage: 'url(' + (back) + ')'}">
          <div class="menu-sp-text">S</div>
          <div class="menu-sp-left">
            <p class="p-text-tea">认证学员</p>
            <p class="p-text-ecturer">TUDENT</p>
          </div>
        </div>
        <div class="site-menu-ul clearfix">
          <div class="site-menu-con" v-for="(item,index) in certifySiteMenu" :key="index">
            <div
              class="clearfix site-menu-li"
              :class="{menuActive : menuActiveName == item.name}"
              @click="tabParentMenu(item.name,item.childMenu ? item.childMenu[0] : '')"
            >
              {{item.name}}
              <span class="wl-icon-xiangyou" :class="{'rotate' : item.childMenu}"></span>
            </div>
            <div
              v-for="(citem,index) in item.childMenu"
              :key="index"
              class="clearfix site-menu-li site-menu-child-li"
              :class="{menuActive : cildActiveName == citem}"
              @click="tabChildMenu(item.name,citem,index)"
            >
              <i class="wl-icon-dian"></i>
              {{citem}}
            </div>
          </div>
        </div>
      </div>
      <div class="wl-flow-content">
        <div class="authen-hade-title clearfix">
          <h3 class="h3-text-title">
            <span v-if="cildActiveName != ''">{{cildActiveName}}</span>
            <span v-else>{{menuActiveName}}</span>
          </h3>
          <div class="authen-hade-crumbs">
            <i class="wl-icon-zhuye1"></i>
            <span>当前位置：</span>
            <span @click="goHome">网站首页</span>
            <span>></span>
            <span @click="goSource" v-if="cildActiveName != ''">{{cildActiveName}}</span>
            <span v-else>{{menuActiveName}}</span>
            <span v-if="!isDetail">
              <span>></span>
              <span>{{title}}</span>
            </span>
            <span v-if="!isShowDetail">
              <span>></span>
              <span>{{activeTitle}}</span>
            </span>
          </div>
        </div>
        <div class="flow-text-content">
          <div class="ability-authen-standard clearfix" v-show="menuActiveName == '物流能力申请标准'">
            <div v-for="(item,index) in authenticationNodeList" :key="index">
              <h3 class="h3-wl-title">
                <span class="sp-border-class"></span>
                <span class="sp-title-text">{{item.Title}}</span>
              </h3>
              <div class="exam-text-content clearfix">
                <p v-html="item.Content"></p>
              </div>
            </div>
          </div>
          <div class="stu-active-content" v-show="menuActiveName == '学员考证活动'">
            <div class="stu-active-list" v-show="isShowDetail">
              <div class="choice-site-list clearfix">
                <div class="choice-site-province">
                  <span>省份：</span>
                  <el-select v-model="value" @change="getSitesList" clearable placeholder="请选择">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="choice-site-name">
                  <span>站点名称：</span>
                  <el-select v-model="siteName" @change="search" filterable clearable placeholder="请选择">
                    <el-option
                      v-for="item in SiteList"
                      :key="item.Id"
                      :label="item.SiteName"
                      :value="item.SiteName"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div
                class="training-active-list"
                v-for="(item,index) in siteActivity"
                :key="index"
                @click="goActiveDetail(item.title,item.id)"
              >
                <div class="training-active-li">
                  <p class="p-title-text">
                    <i class="wl-icon-zhedie"></i>
                    {{item.title}}
                  </p>
                  <p class="p-content-text">{{item.contentText}}</p>
                  <p class="p-source-text clearfix">
                    <span v-if="item.siteName!=''">来源:{{item.siteName}}</span>
                    <span v-else>来源:系统管理员</span>
                    <span class="sp-right">{{item.pulishTime}}</span>
                  </p>
                </div>
              </div>
              <div class="el-block-pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageIndex"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  v-show="total>0"
                ></el-pagination>
              </div>
            </div>
            <activeDetail v-if="!isShowDetail" :activeId="activeId"></activeDetail>
          </div>
          <div class="my-textual-research" v-show="menuActiveName == '我要考证'">
            <h3 class="h3-wl-title">
              <span class="sp-border-class"></span>
              <span class="sp-title-text">物流能力认证考核考试流程</span>
            </h3>
            <div class="exam-text-content clearfix">
              <p>
                <img :src="flowImg" alt>
              </p>
            </div>
            <h3 class="h3-wl-title">
              <span class="sp-border-class"></span>
              <span class="sp-title-text">物流能力认证考核时间</span>
            </h3>
            <div class="exam-text-content clearfix">
              <p>每年5 月第三个周日和11 月第二个周日。</p>
            </div>
            <h3 class="h3-wl-title">
              <span class="sp-border-class"></span>
              <span class="sp-title-text">物流能力认证考核流程</span>
            </h3>
            <div class="exam-text-content clearfix">
              <p>物流能力认证考核知识体系[134]号文件的规定,为了与国际接轨，国家于2005年大力推行职业资格认证制度，要求五年内使80%物流从业人员必须持有相应的职业资格证书，物流业持证上岗将是大势所趋，物流贯穿企业的采购、生产、仓储、销售、运输、配送等环节，无论是生产企业还是第三方物流企业都面临着物流流程再造，而物流教育的滞后，使得物流人才非常匮乏，成为行业发展的瓶颈，物流人才也成为十大紧缺人才之一。</p>
            </div>
            <div class="textual-research-button" @click="applyTea">立即考证 ></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :show-close="true"
      :visible.sync="scanVisible"
      top="12%"
      width="500px"
      class="unified-login-dialog-style"
      :close-on-click-modal="false"
    >
      <!-- <div class="login-role-tab">
        <div
          class="login-role-tab-li"
          @click="roleTab('1')"
          :class="{'active_role' : isRoleTab == '1'}"
        >我是学员</div>
        <div
          class="login-role-tab-li"
          @click="roleTab('2')"
          :class="{'active_role' : isRoleTab == '2'}"
        >我是讲师</div>
      </div> -->
      <div class="login-hade-tab clearfix">
        <div
          class="user-account-login"
          @click="switchTab('account')"
          :class="{'active_login' : isLoginTab == 'account'}"
        >账号登录</div>
        <div
          class="user-phone-login"
          @click="switchTab('phone')"
          :class="{'active_login' : isLoginTab == 'phone'}"
        >手机号登录</div>
      </div>
      <div class="login-form-input clearfix">
        <el-form ref="form" :model="ruleForm" :rules="rules">
          <div class="from-account-login" v-show="isLoginTab == 'account'">
            <el-form-item prop="userName">
              <el-input placeholder="请输入账号" prefix-icon="wl-icon-user" v-model="ruleForm.userName"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="请输入密码"
                prefix-icon="wl-icon-mimaicon"
                v-model="ruleForm.password"
                type="password"
                @keyup.enter.native="login()"
              ></el-input>
            </el-form-item>
          </div>
          <div class="from-phone-login" v-show="isLoginTab == 'phone'">
            <el-form-item prop="phone">
              <el-input
                placeholder="请输入手机号"
                prefix-icon="wl-icon-shouji2"
                v-model="ruleForm.phone"
                @blur="verificationMobile"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha-phone-input">
                <el-input
                  placeholder="请输入手机验证码"
                  prefix-icon="wl-icon-2yanzhengma"
                  v-model="ruleForm.captcha"
                ></el-input>
              </div>
              <el-button
                v-show="show1"
                type="primary"
                class="captcha-phone-button"
                @click="sendMessage()"
              >获取验证码</el-button>
              <el-button v-show="show2" type="primary" class="captcha-phone-button">{{count}}s</el-button>
              <el-button
                v-show="show3"
                type="primary"
                class="captcha-phone-button"
                @click="sendMessage()"
              >重新获取验证码</el-button>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button v-if="isLoginTab == 'account'" type="primary" @click="login">登录</el-button>
            <el-button v-if="isLoginTab == 'phone'" type="primary" @click="Phonelogin()">登录</el-button>
          </el-form-item>
          <div class="go-register-right" @click="goRegister">
            去注册
            <i class="wl-icon-zhankai"></i>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sourseDetail from "page/component/school/studySource.vue";
import activeDetail from "page/component/school/activeDetail.vue";
import { MU_UPATE_AUTH } from "store/index";
import redirect from "api/v1.commom.login.ts";
import CryptoJS from "crypto-js";
export default {
  created() {
    this.getSitesList();
    this.getAllProvinceList();
    this.getAuthenticationNodeList("初级申请标准");
  },
  components: {
    sourseDetail,
    activeDetail
  },
  data() {
    return {
      title: "",
      sourseId: "",
      isDetail: true,
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      back: require("assets/images/bg-xy.png"),
      flowImg: require("assets/images/kzlc.png"),
      defaultCover: require("assets/images/new-course-cover.jpg"),
      menuActiveName: "物流能力申请标准",
      cildActiveName: "初级申请标准",
      gradeRole: "初级物流师",
      competenceStandard: ["初级物流师", "中级物流师", "高级物流师"],
      certifySiteMenu: [
        {
          name: "物流能力申请标准",
          childMenu: ["初级申请标准", "中级申请标准", "高级申请标准"]
        },
        {
          name: "学员考证活动",
          childMenu: ["学员培训", "考试信息"]
        },
        {
          name: "我要考证",
          childMenu: ""
        }
      ],
      value: "",
      input: "",
      activeId: "",
      activeTitle: "",
      isShowDetail: true,
      type: 3,
      siteName: "",
      SiteList: [],
      provinceList: [],
      siteActivity: [],
      LearningMaterialList: [],
      authenticationNodeList: [],
      standardIndex: 0,
      levelType: 1,
      stuName: "",
      stuNumber: "",
      stuCover: "",
      show: 0,
      // 登录
      scanVisible: false,
      ruleForm: {
        userName: "",
        password: "",
        phone: "",
        captcha: ""
      },
      rules: {
        userName: [
          { required: true, message: "请输入用户账号", trigger: "change" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "change" }],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" }
        ]
      },
      count: 60,
      show1: true,
      show2: false,
      show3: false,
      isLoginTab: "account",
      isRoleTab: "1",
      isShow: false
    };
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    },
    userInfo() {
      return this.$store.state.auth;
    }
  },
  methods: {
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    goSource() {
      this.isDetail = true;
      this.isShowDetail = true;
    },
    goDetail(id, title) {
      this.isDetail = false;
      this.title = title;
      this.sourseId = id;
    },
    goActiveDetail(title, id) {
      this.activeTitle = title;
      this.activeId = id;
      this.isShowDetail = false;
    },
    tabParentMenu(name, childMenu) {
      this.menuActiveName = name;
      this.cildActiveName = childMenu;
      this.isDetail = true;
      this.isShowDetail = true;
      if(name == '物流能力申请标准'){
           this.getAuthenticationNodeList(childMenu);
      }
     
      if (name == "学员考证活动") {
        this.getAttestationList();
      }
    },
    tabChildMenu(name, citem, index) {
      this.isDetail = true;
      this.isShowDetail = true;
      this.menuActiveName = name;
      this.cildActiveName = citem;
      this.standardIndex = index;
      this.value = '',
      this.siteName ='',
      this.stuName = '',
      this.stuNumber = '',
      this.stuCover = '',
      // this.getAuthenticationNodeList(citem);
      this.gradeRole = this.competenceStandard[index];
      if (citem == "学员培训") {
        this.type = 3;
        this.getAttestationList();
      } else if (citem == "考试信息") {
        this.type = 4;
        this.getAttestationList();
      }
      if (citem == "初级申请标准") {
        this.getAuthenticationNodeList(citem);
      } else if (citem == "中级申请标准") {
        this.getAuthenticationNodeList(citem);
      } else if (citem == "高级申请标准") {
        this.getAuthenticationNodeList(citem);
      }
    },
    //获取认证活动
    getAttestationList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/AttestationActivity/getAttestation", {
          type: that.type,
          associationId: that.association.Id,
          siteName: that.siteName,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            that.siteActivity = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //获取站点列表
    getSitesList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AttestationActivity/getSiteList", {
          province: that.value
        })
        .then(rst => {
          if (rst.code == 1) {
            that.SiteList = rst.siteList;
          } else {
            that.$message.warning(res.msg);
          }
        });
    },
    //获取省份列表
    getAllProvinceList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AttestationActivity/getAllProvinceList")
        .then(rst => {
          if (rst.code == 1) {
            that.provinceList = rst.province;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //根据标准Id获取认证节点
    getAuthenticationNodeList(name) {
      var that = this;
      this.$http
        .post("/api/XOrg/AuthenticationShow/getAuthenticationNodeList", {
          authenticationTitle: name
        })
        .then(rst => {
          if (rst.code == 1) {
            that.authenticationNodeList =
              rst.authentication.authenticationNodeList;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //查询学员证书
    ckeckStuCertificate() {
        if(this.stuName != '' && this.stuNumber != ''){
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationIndex/getStudentCertificate", {
                name: that.stuName,
                number: that.stuNumber
                })
                .then(rst => {
                if (rst.code == 1) {
                    that.show = 1;
                    that.stuCover = rst.certificateInfo.stuCover;
                } else {
                    // that.stuNumber = '';
                    // that.stuName = '';
                    that.$message.warning(rst.msg);
                }
            });
        }else{
            this.$message.warning('请输入您的姓名和证书编号');
        }
    },
    search() {
      this.getAttestationList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAttestationList(1);
    },
    handleCurrentChange(val) {
      this.getAttestationList(val);
    },
    applyTea() {
      let that = this;
      if (that.userInfo.code > 0 && that.userInfo.userType == 1) {
        this.$router.push({
          name: "testResearch"
        });
      } else {
        this.scanVisible = true;
      }
    },
    roleTab(role) {
      this.isRoleTab = role;
    },
    login: function() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Accountlogin", {
          userName: that.ruleForm.userName,
          userPwd: that.ruleForm.password,
          associationId: that.association.Id
        })
        .then(function(rst) {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = that.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            that.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.loadingTip(false);
              // 登录完获取回登录信息跳转
              that.scanVisible = false;
              that.$router.push({
                name: "testResearch"
              });
            });
          } else {
            that.loadingTip(false);
            that.$message.warning(rst.msg);
          }
        });
    },
    //手机登录
    Phonelogin() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Phonelogin", {
          phone: that.ruleForm.phone,
          captcha: that.ruleForm.captcha,
          associationId: that.association.Id
        })
        .then(rst => {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = that.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            that.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.loadingTip(false);
              // 登录完获取回登录信息跳转
              that.scanVisible = false;
              that.$router.push({
                name: "testResearch"
              });
            });
          } else {
            that.loadingTip(false);
            that.$message.warning(rst.msg);
          }
        });
    },
    loadingTip(is) {
      // let loading = null;
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    verificationMobile() {
      var re = /^1\d{10}$/;
      if (re.test(this.ruleForm.phone)) {
      } else {
        this.$message.warning("手机号格式不正确");
        return false;
      }
    },
    //验证码
    sendMessage() {
      var once = true;
      let str_ = Date.parse(new Date()) / 1000;
      let str = this.encryption(str_);
      let str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;
      if (once) {
        var that = this;
        this.$http("/api/XOrg/XLogin/sendCode", {
          verifyInfo: this.ruleForm.phone,
          str: str,
          str1: str1
        }).post(rst => {
          if (rst.code > 0) {
            this.$message.success(rst.msg);
            this.verifyCode = rst.verifyCode;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show1 = false;
              this.show2 = true;
              this.show3 = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                  once = false;
                } else {
                  this.show1 = false;
                  this.show2 = false;
                  this.show3 = true;
                  clearInterval(this.timer);
                  this.timer = null;
                  once = true;
                }
              }, 1000);
            }
          } else {
            this.$message.warning(rst.msg);
          }
        });
      }
    },
    encryption: function(str) {
      let Base64 = require("js-base64").Base64;
      return Base64.encode(str);
    },
    goRegister() {
      this.$router.push({
        name: "register"
      });
    },
    switchTab(content){
      this.isLoginTab = content;
    },
  }
};
</script>
